import { render, staticRenderFns } from "./TextCardTranslation.vue?vue&type=template&id=8e77e2b6"
import script from "./TextCardTranslation.vue?vue&type=script&lang=js"
export * from "./TextCardTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports